import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import { ToastContainer, toast } from 'react-toastify';
import { bannerAPI, newsAPI, videoAPI, adsAPI, imagaeAPI, YouTubevideoAPI, BengaluruNewsAPI, KarnatakaNewsAPI, NationalNewsAPI, YouTubevideoMetroAPI } from '../../services/api';
import Header from './Header';
import Footer from './Footer';

// Swiper CSS
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// React Toastify CSS
import 'react-toastify/dist/ReactToastify.css';

// ---------- Main Homepage Component ----------
const AboutUs = () => {
    // State
    const [loading, setLoading] = useState(false);
    const [banners, setBanners] = useState([]);
    const [allNews, setAllNews] = useState([]);
    const [videos, setVideos] = useState([]);
    const [ads, setAds] = useState([]);
    const [temperature, setTemperature] = useState('Loading...');
    const [youtubevideos, setYouTubeVideos] = useState([]);
    const [youtubevideosmetro, setYouTubeVideosMetro] = useState([]);
    const [error, setError] = useState(null);

    const [bengaluruallNews, setBengaluruAllNews] = useState([]);
    const [karnatakaallNews, setKarnatakaAllNews] = useState([]);
    const [nationalallNews, setNationalAllNews] = useState([]);


    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        return new Date(dateStr).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });

    };





    const fetchAds = async () => {
        setLoading(true);
        try {
            const res = await adsAPI.getAll();
            setAds(res.data.data);
        } catch (error) {
            console.error("Error fetching ads:", error);
        }
        finally {
            setLoading(false);
        }
    };



    const getAds = () =>
        ads.filter(n => n.status === 'active');



    useEffect(() => {



        fetchAds();


        fetch('https://wttr.in/Bengaluru?format=j1')
            .then(res => res.json())
            .then(data => {
                setTemperature(data.current_condition[0].temp_C + '°C');
            })
            .catch(() => setTemperature('N/A'));

    }, []);


    if (loading) {
        return (
            <div className="main-content" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }



    // ---------- Render ----------
    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} />

            <Header temperature={temperature} />


            {/* ===== MAIN CONTENT ===== */}
            <main>

                {/* ---------- BENGALURU NEWS ---------- */}
                <section className="trending-posts-4__area trending-posts-4__space grey-bg section-space-bottom">
                    <div className="container custom-container">
                        <div className="trending-posts-4__top heading-display__wrap">
                            <div className="section-heading__wrap">
                                <h3 className="section__title wow custom-anim-left" data-wow-duration="1s" data-wow-delay="0.1s">
                                    Advisory Board
                                </h3>
                                <div className="section__border wow custom-anim-left" data-wow-duration="1s" data-wow-delay="0.1s" />
                            </div>

                        </div>
                        <div className="row mb-minus-24">
                            {/* Left Side */}
                            <div className="col-lg-8 primary_bg4">
                                <div className="trending-posts-4__wrapper mb-24">

                                    <div className="table-responsive">
                                        <table className="table table-bordered text-center align-middle mb-0">
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <img
                                                            src={`${process.env.PUBLIC_URL}/assets/img/advisory/1.jpg`}
                                                            className="img-fluid"
                                                            alt="1"
                                                        />
                                                    </td>
                                                    <td>
                                                        <img
                                                            src={`${process.env.PUBLIC_URL}/assets/img/advisory/2.jpg`}
                                                            className="img-fluid"
                                                            alt="2"
                                                        />
                                                    </td>
                                                    <td>
                                                        <img
                                                            src={`${process.env.PUBLIC_URL}/assets/img/advisory/3.jpg`}
                                                            className="img-fluid"
                                                            alt="3"
                                                        />
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td><img src={`${process.env.PUBLIC_URL}/assets/img/advisory/4.jpg`} className="img-fluid" alt="4" /></td>
                                                    <td><img src={`${process.env.PUBLIC_URL}/assets/img/advisory/5.jpg`} className="img-fluid" alt="5" /></td>
                                                    <td><img src={`${process.env.PUBLIC_URL}/assets/img/advisory/6.jpg`} className="img-fluid" alt="6" /></td>
                                                </tr>

                                                <tr>
                                                    <td><img src={`${process.env.PUBLIC_URL}/assets/img/advisory/7.jpg`} className="img-fluid" alt="7" /></td>
                                                    <td><img src={`${process.env.PUBLIC_URL}/assets/img/advisory/8.jpg`} className="img-fluid" alt="8" /></td>
                                                    <td><img src={`${process.env.PUBLIC_URL}/assets/img/advisory/9.jpg`} className="img-fluid" alt="9" /></td>
                                                </tr>

                                                <tr>
                                                    <td><img src={`${process.env.PUBLIC_URL}/assets/img/advisory/10.jpg`} className="img-fluid" alt="10" /></td>
                                                    <td><img src={`${process.env.PUBLIC_URL}/assets/img/advisory/11.jpg`} className="img-fluid" alt="11" /></td>
                                                    <td><img src={`${process.env.PUBLIC_URL}/assets/img/advisory/12.jpg`} className="img-fluid" alt="12" /></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>

                            {/* Right Side */}
                            <div className="col-lg-4">
                                <div className="blog-sidebar__wrapper">
                                    <div
                                        className="blog-sidebar__wrap mb-20 wow fadeInUp"
                                        data-wow-duration="0.7s"
                                        data-wow-delay="0.2s"
                                    >
                                        <h3 className="blog-sidebar__title">Advertisement</h3>

                                        <div className="blog-sidebar__gallery blog-sidebar__gallery-2">
                                            {ads.length > 0 &&
                                                ads.map((ad) => (
                                                    <div key={ad.id} className="mb-3">
                                                        <img
                                                            src={`${imagaeAPI}/uploads/ads/${ad.ads_photo}`}
                                                            alt={ad.ads_title}
                                                            className="img-fluid w-100"
                                                        />
                                                    </div>
                                                ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>














            </main >

            {/* ===== FOOTER ===== */}

            < Footer />

        </>
    );
};

// ---------- SUBCOMPONENTS ----------



export default AboutUs;